import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton } from "@ionic/react";

// css
import "../Shared.css";
import "../../App.css";
import "./TrustPinCell.css";

// controllers
import { IScreenProps, IUser, ITrustPin } from "../Interfaces";

// images
import furtherResourceIcon from "../assets/Icon_FurtherResources@3x.png";
import disclosureRight from "../assets/Button_Disclosure_Right_Grey50@3x.png";

type Props = {
  trustPin: ITrustPin;
  icon: null | string;
  cellClicked?: (trustPin: ITrustPin) => void;
};
type State = {};

class TrustPinCell extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  cellClicked() {
    if (this.props.cellClicked) {
      this.props.cellClicked(this.props.trustPin);
    }
  }

  render() {
    let imageSrc = furtherResourceIcon;
    let icon = this.props.icon;

    if (icon != null) {
      imageSrc = icon;
    }

    return (
      <div className="trustPinCell" tabIndex={0} role="button" onClick={this.cellClicked.bind(this)}>
        <div className="trustPinCellContents">
          <img className="trustPinCellIcon" src={imageSrc} />

          <div className="trustPinCellText">{this.props.trustPin.name}</div>
        </div>
        <img alt="" src={disclosureRight} className="icon-44" />
      </div>
    );
  }
}

export default TrustPinCell;
